import { render, staticRenderFns } from "./CreaNivelTres.vue?vue&type=template&id=5b4e9e31"
import script from "./CreaNivelTres.vue?vue&type=script&lang=js"
export * from "./CreaNivelTres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports